export default "__VITE_ASSET__d622e71a__"